'use client';
import {
  Box,
  Button,
  Collapse,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import Image from 'next/image';
import { MdCheck, MdClose } from 'react-icons/md';
import { BiMinus, BiPlus } from 'react-icons/bi';
import { useState } from 'react';

const securityOptions = [
  { title: 'امنیت بالا', doresaz: true, spot: true, kavimo: false },
  {
    title: 'عدم امکان اسکرین رکورد**',
    doresaz: false,
    spot: false,
    kavimo: false,
  },
  {
    title: 'غیر قابل دانلود شدن دوره‌ها',
    doresaz: true,
    spot: true,
    kavimo: false,
  },
  {
    title: 'تشخیص مهاجمین با هوش مصنوعی',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
  {
    title: 'امکان پخش مستقیم و بدون نصب نرم افزار اضافی',
    doresaz: true,
    spot: false,
    kavimo: true,
  },
  {
    title: 'رمزنگاری پیشرفته و امن در تمامی پلتفرم‌ها (وب-IOS...)',
    doresaz: true,
    spot: true,
    kavimo: false,
  },
];

const marketingOptions = [
  {
    title: ' همکاری در فروش - Affiliate marketing',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
  {
    title: 'امکان فعال سازی خرید اقساطی دوره ها*',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
  {
    title: 'بازاریابی خودکار - Marketing Automation ',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
  {
    title: 'درگاه پرداخت اختصاصی برای مدرسین',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
];

const specialOptions = [
  { title: 'تعریف آزمون*', doresaz: true, spot: true, kavimo: false },
  { title: 'اجرای نظرسنجی*', doresaz: true, spot: false, kavimo: false },
  { title: 'درج مقاله در وب*', doresaz: true, spot: false, kavimo: false },
  { title: 'سیستم گزارشگیری جامع', doresaz: true, spot: false, kavimo: false },
  {
    title: 'صفحه شخصی برای هر مدرس',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
  {
    title: 'اتصال دامنه شخصی به لندینگ*',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
  {
    title: 'سیستم مشتاق سازی دانشجویان به اتمام دوره - Gamification*',
    doresaz: true,
    spot: false,
    kavimo: false,
  },
];

const useOptions = [
  {
    title: 'سازگار با تمامی دیوایس‌ها (IOS-Android...)',
    doresaz: true,
    spot: false,
    kavimo: true,
  },
  { title: 'پشتیبانی 24/7', doresaz: true, spot: true, kavimo: true },
  {
    title: 'مناسب کسب و کارهای کوچک',
    doresaz: true,
    spot: true,
    kavimo: false,
  },
  {
    title: 'مناسب کسب و کارهای بزرگ',
    doresaz: true,
    spot: false,
    kavimo: true,
  },
];

const CompareSection = () => {
  const muiTheme = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Typography
        sx={{
          fontSize: { xs: 18, sm: 36, md: 48 },
          fontWeight: { xs: 600, sm: 500 },
          color: 'secondary.main',
          textAlign: 'center',
        }}>
        مقایسه دوره ساز با رقبا
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', spacing: 2, mt: 4 }}>
        <Box sx={{ flex: 3 }}></Box>
        <Box
          sx={{
            flex: 4,
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
          }}>
          <Box
            sx={{
              position: 'relative',
              width: { xs: 35, sm: 50, md: 70 },
              height: { xs: 35, sm: 50, md: 70 },
            }}>
            <Image
              sizes="(max-width: 768px) 50vw, (max-width: 1024px) 75vw, 100vw"
              fill
              src="/svg/light-logo.svg"
              alt="ساخت دوره آنلاین"
            />
          </Box>
          <Box
            sx={{
              position: 'relative',
              width: { xs: 35, sm: 50, md: 70 },
              height: { xs: 35, sm: 50, md: 70 },
            }}>
            <Image
              sizes="(max-width: 768px) 50vw, (max-width: 1024px) 75vw, 100vw"
              fill
              src="/img/spot-icon.png"
              alt="سایت فروش دوره"
            />
          </Box>
          <Box
            sx={{
              position: 'relative',
              width: { xs: 35, sm: 50, md: 70 },
              height: { xs: 35, sm: 50, md: 70 },
            }}>
            <Image
              sizes="(max-width: 768px) 50vw, (max-width: 1024px) 75vw, 100vw"
              fill
              src="/img/kavimo-icon.png"
              alt="فروش دوره آموزشی"
            />
          </Box>
        </Box>
      </Box>
      <Stack spacing={4} mt={2}>
        <Box>
          <Box>
            <Typography fontSize={{ xs: 18, sm: '1.5rem' }} fontWeight={600}>
              ویژگی‌های امنیتی
            </Typography>
          </Box>
          <Stack gap={2} mt={2}>
            {securityOptions.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <Box
                  sx={{
                    flex: 3,
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Typography fontSize={{ xs: 15, sm: 16 }}>
                    {item.title}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    flex: 4,
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    fontSize: 32,
                  }}>
                  <Box
                    sx={{
                      color: item.doresaz ? 'secondary.main' : 'error.main',
                    }}>
                    {item.doresaz ? (
                      <MdCheck size={22} name="سایت فروش محتوای آموزشی" />
                    ) : (
                      <MdClose size={22} name="سایت فروش دوره های آموزشی" />
                    )}
                  </Box>

                  <Box
                    sx={{ color: item.spot ? 'secondary.main' : 'error.main' }}>
                    {item.spot ? <MdCheck size={22} /> : <MdClose size={22} />}
                  </Box>
                  <Box
                    sx={{
                      color: item.kavimo ? 'secondary.main' : 'error.main',
                    }}>
                    {item.kavimo ? (
                      <MdCheck size={22} />
                    ) : (
                      <MdClose size={22} />
                    )}
                  </Box>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
        <Box>
          <Box>
            <Typography fontSize={{ xs: 18, sm: '1.5rem' }} fontWeight={600}>
              امکانات بازاریابی و فروش
            </Typography>
          </Box>
          <Stack gap={2} mt={2}>
            {marketingOptions.map((item, index) => (
              <Box
                key={index}
                sx={{ display: 'flex', alignItems: 'center', spacing: 2 }}>
                <Box
                  sx={{
                    flex: 3,
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Typography fontSize={{ xs: 15, sm: 16 }}>
                    {item.title}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    flex: 4,
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    fontSize: 32,
                  }}>
                  <Box
                    sx={{
                      color: item.doresaz ? 'secondary.main' : 'error.main',
                    }}>
                    {item.doresaz ? (
                      <MdCheck size={22} />
                    ) : (
                      <MdClose size={22} />
                    )}
                  </Box>

                  <Box
                    sx={{ color: item.spot ? 'secondary.main' : 'error.main' }}>
                    {item.spot ? <MdCheck size={22} /> : <MdClose size={22} />}
                  </Box>
                  <Box
                    sx={{
                      color: item.kavimo ? 'secondary.main' : 'error.main',
                    }}>
                    {item.kavimo ? (
                      <MdCheck size={22} />
                    ) : (
                      <MdClose size={22} />
                    )}
                  </Box>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
        <Collapse in={open}>
          <Box>
            <Box>
              <Typography fontSize={{ xs: 18, sm: '1.5rem' }} fontWeight={600}>
                امکانات ویژه
              </Typography>
            </Box>
            <Stack gap={2} mt={2}>
              {specialOptions.map((item, index) => (
                <Box
                  key={index}
                  sx={{ display: 'flex', alignItems: 'center', spacing: 2 }}>
                  <Box
                    sx={{
                      flex: 3,
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                    <Typography fontSize={{ xs: 15, sm: 16 }}>
                      {item.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flex: 4,
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      fontSize: 32,
                    }}>
                    <Box
                      sx={{
                        color: item.doresaz ? 'secondary.main' : 'error.main',
                      }}>
                      {item.doresaz ? (
                        <MdCheck size={22} />
                      ) : (
                        <MdClose size={22} />
                      )}
                    </Box>

                    <Box
                      sx={{
                        color: item.spot ? 'secondary.main' : 'error.main',
                      }}>
                      {item.spot ? (
                        <MdCheck size={22} />
                      ) : (
                        <MdClose size={22} />
                      )}
                    </Box>
                    <Box
                      sx={{
                        color: item.kavimo ? 'secondary.main' : 'error.main',
                      }}>
                      {item.kavimo ? (
                        <MdCheck size={22} />
                      ) : (
                        <MdClose size={22} />
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Box>
          <Box mt={4}>
            <Box>
              <Typography fontSize={{ xs: 18, sm: '1.5rem' }} fontWeight={600}>
                سهولت در استفاده
              </Typography>
            </Box>
            <Stack gap={2} mt={2}>
              {useOptions.map((item, index) => (
                <Box
                  key={index}
                  sx={{ display: 'flex', alignItems: 'center', spacing: 2 }}>
                  <Box
                    sx={{
                      flex: 3,
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                    <Typography fontSize={{ xs: 15, sm: 16 }}>
                      {item.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      flex: 4,
                      display: 'flex',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      fontSize: 32,
                    }}>
                    <Box
                      sx={{
                        color: item.doresaz ? 'secondary.main' : 'error.main',
                      }}>
                      {item.doresaz ? (
                        <MdCheck size={22} />
                      ) : (
                        <MdClose size={22} />
                      )}
                    </Box>

                    <Box
                      sx={{
                        color: item.spot ? 'secondary.main' : 'error.main',
                      }}>
                      {item.spot ? (
                        <MdCheck size={22} />
                      ) : (
                        <MdClose size={22} />
                      )}
                    </Box>
                    <Box
                      sx={{
                        color: item.kavimo ? 'secondary.main' : 'error.main',
                      }}>
                      {item.kavimo ? (
                        <MdCheck size={22} />
                      ) : (
                        <MdClose size={22} />
                      )}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Box>
        </Collapse>
      </Stack>
      <Box sx={{ mt: 2 }}>
        <Button
          color="secondary"
          sx={{ display: 'flex', gap: 1.5 }}
          endIcon={open ? <BiMinus /> : <BiPlus />}
          onClick={() => {
            setOpen(!open);
          }}>
          {open ? 'بستن' : 'مشاهده بیشتر'}
        </Button>
      </Box>
      <Stack spacing={0.5} mt={2}>
        <Typography variant="caption" color="text.secondary">
          ** در نسخه وب امکان اسکرین رکورد اسپات پلیر وجود دارد
        </Typography>
        <Typography variant="caption" color="text.secondary">
          * ویژگی‌های ستاره دار به زودی از حالت آزمایشی خارج شده و در دسترس قرار
          خواهند گرفت
        </Typography>
      </Stack>
    </>
  );
};

export default CompareSection;
